import { useState, useEffect } from "react"; // Import React hooks
import { ref, query, orderByChild, limitToLast, get } from "firebase/database"; // Import Firebase database functions
import { observer } from "mobx-react-lite";
import { db } from "../firebaseModel";
import GeneralScoreboardView from "../views/generalScoreboardView";

const GeneralScoreboardPresenter = observer(function GeneralScoreboardRender(props) {
    const getTop10Scores = async () => {
        const leaderboardRef = ref(db);
        const allScores = [];
      
        const snapshot = await get(leaderboardRef);
      
        if (snapshot.exists()) {
            
            snapshot.forEach((userSnapshot) => {
                const userData = userSnapshot.val();
                
                Object.values(userData).forEach((user) => {
                    if (user && user.PersonalLeaderboardPromiseState) {
                        console.log("creating general leaderboard");
                        user.PersonalLeaderboardPromiseState.forEach((scoreData) => {
                            allScores.push({ ...scoreData });
                        });
                    }
                });
            });
        }
        console.log(allScores);

        allScores.sort((a, b) => b.score - a.score);
        let userPosition = null;
        for (let index = 0; index < allScores.length; index++) {
            if (allScores[index].username == props.model.username) {
                userPosition = index + 1;
                break;
            }
        }
        return { top10Scores: allScores.slice(0, 10), userPosition };
    };

   const [generalScores, setGeneralScores] = useState({ top10Scores: [], userPosition: null });

   useEffect(() => {
    const fetchTop10Scores = async () => {
        const { top10Scores, userPosition } = await getTop10Scores();
        setGeneralScores({ top10Scores, userPosition });
    };

    fetchTop10Scores();
}, []);

return <GeneralScoreboardView generalScores={generalScores.top10Scores} userPosition={generalScores.userPosition} />;
});

export { GeneralScoreboardPresenter };
